import React from "react";
import { Table, Typography, Divider, Popconfirm } from "antd";
import moment from "moment";

const { Text } = Typography;

const WithdrawalTable = ({
  dataSource,
  openModal,
  spinner,
  pagination,
}) => {
  const column = [
    {
      title: <span>Date</span>,
      dataIndex: "withdrawalDate",
      key: "withdrawalDate",
      render: (record) => <span>{record ? moment(record).format("DD-MM-YYYY HH:mm") : "-"}</span>,
    },
    {
      title: <span>Branch</span>,
      dataIndex: "branch",
      key: "branch",
      render: (record) => <span>{record && record.name}</span>,
    },
    {
      title: <span>Withdrawn By</span>,
      dataIndex: "withdrawnBy",
      key: "withdrawnBy",
      render: (record) => <span>{record && record.profile?.employeeName}</span>,
    },
    {
      title: <span>Total Amount</span>,
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (record) => <span>₹{record ? record.toLocaleString() : "0"}</span>,
    },
    {
      title: <span>Actions</span>,
      key: "actions",
      render: (data) => (
        <div>
          <span
            onClick={(event) => {
              event.stopPropagation();
              openModal(data.id, false);
            }}
            className="linkylink"
          >
            View
          </span>
        </div>
      ),
    },
  ];

  return (
    <Table
      rowKey={(record) => record.id}
      pagination={pagination}
      columns={column}
      style={{ cursor: "pointer" }}
      dataSource={dataSource}
      onRow={(props) => ({
        onClick: () => {
          openModal(props.id, false);
        },
      })}
      loading={spinner}
    />
  );
};

export default WithdrawalTable;
